/**
 * Returns a Promise which resolves after specified duration
 * @see setTimeout
 * @param {number} time delay duration
 * @return {Promise} resolved after time
 */
function delay(time = 10) {
  return new Promise(resolve => setTimeout(resolve, time))
}

export default delay
